module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/templates/App.html -->\n<div id="payrollpandaapp">\n\n    <div class="content"></div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/App.html
// module id = 1086
// module chunks = 1